import React from 'react'
import ChatComponent from './components/ChatComponent/ChatComponent'
class App extends React.Component {
  constructor(props) {
    super(props)
    this.chatComponent = React.createRef()

    console.log(`${process.env.REACT_APP_NAME} ` +
    `v${process.env.REACT_APP_VERSION}`)
  }

  componentDidMount = () => {
    const { chatButtonClickedBeforeMercurioReady } = this.props
    if (chatButtonClickedBeforeMercurioReady) {
      this.triggerOpenChat()
    }
  }

  triggerOpenChat = () => {
    this.chatComponent.current.handleButtonClick()
  }

  isChatOpened = () => {
    const isChatOpen = this.chatComponent?.current?.isChatOpened?.() ?? false

    if(!isChatOpen){
      console.warn('Failed to check if chat is opened. ' +
      'The component is not referenced yet.')
    }

    return isChatOpen
  }

  render() {
    return (
      <ChatComponent
        {...this.props}
        ref={this.chatComponent}
        app='chat-adview-web'
      />
    )
  }
}
export default App
